import api from './api';
import { FileEntity, Kunde, KundeCreate, KundeOverview } from '../types';

export interface SmartLookupResult {
  name_des_unternehmens: string | null;
  adresse_des_unternehmens: string | null;
  strasse: string | null;
  plz: string | null;
  ort: string | null;
  rechnungskontakt: string | null;
  email: string | null;
}

export const kundenService = {
  list: async (): Promise<Kunde[]> => {
    const response = await api.get('/kunden/');
    return response.data;
  },

  get: async (id: number): Promise<Kunde> => {
    const response = await api.get(`/kunden/${id}`);
    return response.data;
  },

  getUebersicht: async (id: number): Promise<KundeOverview> => {
    const response = await api.get(`/kunden/${id}/uebersicht`);
    return response.data;
  },

  create: async (data: KundeCreate): Promise<Kunde> => {
    const response = await api.post('/kunden/', data);
    return response.data;
  },

  update: async (id: number, data: Partial<KundeCreate>): Promise<Kunde> => {
    const response = await api.put(`/kunden/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/kunden/${id}`);
  },

  getFilesToDelete: async (id: number): Promise<FileEntity[]> => {
    const response = await api.get(`/kunden/${id}/files-to-delete`);
    return response.data;
  },

  smartLookup: async (firmenname: string): Promise<SmartLookupResult> => {
    const response = await api.post('/kunden/smart-lookup', { firmenname });
    return response.data;
  },
};
